import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";

// Función que escucha cambios en el documento "Lectura/productos"
export function listenProductos(callback) {
  const docRef = doc(db, "Lectura", "productos");

  const unsubscribe = onSnapshot(docRef, (docSnap) => {
    if (docSnap.exists()) {
      const productosFirebase = docSnap.data().data;
      console.log('listenProductos');
      callback(productosFirebase);
    } else {
      callback([]);
    }
  });

  return unsubscribe;
}